

























































































import { Component, Prop , Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwModal ,  SwModalFooter , SwModalBody } from '@libs-uuif/shared/sw-modal';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { InfoState } from '../../core';
import Papa from 'papaparse';

@Component({
  components: {
    SwButton,
    SwModal,
    SwModalFooter,
    SwModalBody,
    SwIcon,
  },
})

export default class FileUploadmodal extends SwExtendedVue {

  @Prop({ required: true })
  display: boolean;

  @Prop({ required: true })
  heading: boolean;

  @Prop({ required: true })
  buttonName: boolean;

  @Prop({ required: false })
  errorMessage: string = '';

  @Prop({ required: false, default: '' })
  originSrc: string;

  fileRead = new FileReader();

  bulkData :any = [];

  returnedData :any = [];

  fileexist: boolean = false;

  fileName:string = '';

  browseFileName : string = '';

  display2 : boolean = this.display;
  mounted() {
    const copyFileInput = document.getElementById('fileInput') as HTMLInputElement;
    const boxes = document.getElementById('boxes') as HTMLElement;
    boxes.addEventListener('paste', (e : any) => {
      copyFileInput.files = e.clipboardData.files;
      console.warn(e);
    },                     false);
  }

  @Watch('display')
  onDisplayChange(value : any) {
    this.fileexist = false;
    this.display2 = value;
  }

  clickChecked(event:any) {
    if (event.srcElement.className.indexOf('sw-modal--regular') > -1) {
      this.$emit('close-modal', false);
    }
  }

  escapeListener(event:any) {
    if (event.code === 'Escape') {
      this.$emit('close-modal', false);
    }
  }

  uploadFile() {
    this.fileexist = false;
    const fileInput : HTMLElement = document.getElementById('fileInput')!;
    fileInput.click();
  }

  loadText(event :any) {
    const file = event.target.files[0];
    if (file) {
      if (file.name.split('.')[1] === 'csv') {
        if (file.name.length > 20) {
          const tempName = file.name;
          const ext = '...csv';
          this.browseFileName = tempName.substring(0, 13) + ext;
        }else {
          this.browseFileName = file.name;
        }
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const csvData = e.srcElement.result;
          const result = Papa.parse(csvData, {
          header: true,
          skipEmptyLines: true,
          transformHeader(_, index) {
            // Use your custom header(s)
            return ['serialNumber'][index];
          },
        }).data;
          this.returnedData = result;
        };
        reader.readAsText(file);
        this.fileexist = true;
      } else {
        const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('products.invalidFile')
        .toString()) };
        this.$store.commit('enqueueMessage', message);
        this.onDisplayChange(true);
      }
    } else {
      this.onDisplayChange(true);
    }
  }

  onDrop(event: any) {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      if (file.name.split('.')[1] === 'csv') {
        if (file.name.length > 20) {
          const tempName = file.name;
          const ext = '...csv';
          this.browseFileName = tempName.substring(0, 13) + ext;
          this.fileName = tempName.substring(0, 13) + ext;
        }else {
          this.browseFileName = file.name;
          this.fileName = file.name;
        }
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const csvData = e.srcElement.result;
          const result = Papa.parse(csvData, {
          header: true,
          skipEmptyLines: true,
          transformHeader(_, index) {
            // Use your custom header(s)
            return ['serialNumber'][index];
          },
        }).data;
          this.returnedData = result;
        };
        reader.readAsText(file);
        this.fileexist = true;
      } else {
        this.onDisplayChange(true);
        const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('products.invalidFile')
        .toString()) };
        this.$store.commit('enqueueMessage', message);
      }
    } else {
      this.onDisplayChange(true);
    }
  }

  addProduct() {
    if (this.returnedData.length) {
      this.$emit('returned-data', this.returnedData);
      this.$emit('close-modal', false);
    }
  }

}
